import MustChangePassword from "./must_change_password";

export default MustChangePassword;